import { render, staticRenderFns } from "./match2021p.vue?vue&type=template&id=d6038bbe&scoped=true"
import script from "./match2021p.vue?vue&type=script&lang=js"
export * from "./match2021p.vue?vue&type=script&lang=js"
import style0 from "./match2021p.vue?vue&type=style&index=0&id=d6038bbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6038bbe",
  null
  
)

export default component.exports